module.exports = __webpack_public_path__ + "static/img/aepic-15.f4939ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-15.jpg
// module id = VOR6
// module chunks = 51